import IconAutomationNew from "@grabyo/icons-react/dist/IconAutomationNew";
import IconEditorNew from "@grabyo/icons-react/dist/IconEditorNew";
import IconFolders from "@grabyo/icons-react/dist/IconFolders";
import IconLiveClipping from "@grabyo/icons-react/dist/IconLiveClipping";
import IconHomeNew from "@grabyo/icons-react/dist/IconHomeNew";
import IconOrganizationNew from "@grabyo/icons-react/dist/IconOrganizationNew";
import IconProducer3 from "@grabyo/icons-react/dist/IconProducer3";

export const pages = [
    {
        label: `Home`,
        href: `/`,
        legacyHref: `/home.jsp`,
        Icon: IconHomeNew
    },
    {
        label: `Producer`,
        href: `/producer`,
        legacyHref: `/producer`,
        asideHrefs: [
            `/producer`,
            `/producer/audio-mixer`,
            `/producer/replay-controls`
        ],
        Icon: IconProducer3,
        active: true,
        feature: `cloudProducerEnabled`
    },
    {
        label: `Live clipping`,
        href: `/clipper`,
        legacyHref: `/trim.jsp`,
        Icon: IconLiveClipping
    },
    {
        label: `Editor`,
        href: `/editor`,
        legacyHref: `/editor.jsp`,
        Icon: IconEditorNew,
        feature: `editorEnabled`
    },
    {
        label: `Campaign`,
        href: `/campaign`,
        legacyHref: `/studiolibrary.jsp`,
        Icon: IconFolders
    },
    {
        label: `Automation`,
        href: `/automation`,
        legacyHref: `/automation.jsp`,
        Icon: IconAutomationNew,
        feature: `automationEnabled`
    },
    {
        label: `Organization`,
        href: `/organization`,
        legacyHref: `/organization`,
        Icon: IconOrganizationNew,
        admin: true
    },
    {
        href: `/producer/multiviewer`,
        legacyHref: `/multiviewer.jsp`,
        feature: `multiviewerAsideLink`
    }
];
